let color_cache = {}

// modified from
// https://www.sitepoint.com/javascript-generate-lighter-darker-color/
const fill = (hex, op) => {
  let color_index = `fil--${hex}--${op}`
  // use cache to avoid recalculation
  if (!!color_cache[color_index]) return color_cache[color_index]

  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '')
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
  }
  op = op || 0

  // convert to decimal and change luminosity
  var rgb = '#',
    c,
    i
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16)
    // fill formula towards white
    c = Math.round(Math.min(Math.max(0, 255 - op * (255 - c)), 255)).toString(16)
    rgb += ('00' + c).substr(c.length)
  }

  color_cache[color_index] = rgb
  return rgb
}

export {fill}
